<div class="excel-upload-container">
  <div class="file-input-row" style="display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: wrap;">
    <div style="flex: 1; min-width: 0;">
      <label for="projectBainExcelFile">Select Excel file</label>
      <input
        #projectBainExcelFileInput
        id="projectBainExcelFile"
        type="file"
        accept=".xlsx"
        (change)="onFileChange($event)"
        [disabled]="isValidating || isUploading"
        aria-label="Upload Project Bain Targets Excel file"
      />
      <small>Accepted types: .xlsx</small>
    </div>
    <!-- Download Sample Excel & Last Updated -->
    <div style="display: flex; flex-direction: column; align-items: flex-end; gap: 8px;">
      <a
        class="btn btn-link px-0"
        href="assets/samples/Project Bain Targets.xlsx"
        download="Project Bain Targets.xlsx"
        [attr.aria-label]="'Download sample Excel'"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
            fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
          <path d="M.5 9.9v2.6A2.5 2.5 0 0 0 3 15h10a2.5 2.5 0 0 0 2.5-2.5V9.9a.5.5 0 0 0-1 0v2.6A1.5 1.5 0 0 1 13 14H3a1.5 1.5 0 0 1-1.5-1.5V9.9a.5.5 0 0 0-1 0z"/>
          <path d="M7.646 10.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 9.293V1.5a.5.5 0 0 0-1 0v7.793L5.354 7.146a.5.5 0 1 0-.708.708l3 3z"/>
        </svg>
        <span class="ms-1">Download sample Excel</span>
      </a>
      <div *ngIf="lastUpdatedOn">
        <small>Last updated on: {{ lastUpdatedOn | date:'dd/MM/yyyy' }}</small>
      </div>
    </div>
  </div>

  <div *ngIf="selectedFileName" class="file-info">
    <div><strong>File:</strong> {{ selectedFileName }}</div>
    <div *ngIf="selectedFileSize"><strong>Size:</strong> {{ selectedFileSize }} bytes</div>
  </div>

  <div *ngIf="errorMessage" class="message error">{{ errorMessage }}</div>
  <div *ngIf="successMessage" class="message success">{{ successMessage }}</div>

  <div class="actions">
    <button type="button" class="upload-btn" (click)="uploadExcel()" [disabled]="!canUpload">
      Upload
    </button>
    <button type="button" class="btn-clear" (click)="clearSelection()" [disabled]="isValidating || isUploading">
      Clear
    </button>
    <button type="button" class="upload-btn" (click)="viewUploadedData()" [disabled]="isUploading || isValidating || !canViewData">
      View Uploaded Data
    </button>
  </div>
  <br/>
  <div *ngIf="validationSummary" class="alert alert-danger">{{ validationSummary }}</div>
  <br/>
  <!-- Validation Error Table (from file upload) -->
  <div *ngIf="validationRows?.length" class="validation-table-wrapper validation-error-table">
    <div class="table-scroll-container">
      <table class="validation-table">
        <thead>
          <tr>
            <th *ngFor="let col of validationColumns">{{ col }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of validationRows">
            <td *ngFor="let col of validationColumns">
              {{ row[col] }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- View Uploaded Data Table (from database) -->
  <div *ngIf="viewColumns.length" class="validation-table-wrapper view-data-table">
    <div class="table-scroll-container">
      <table class="validation-table">
        <thead>
          <tr>
            <th *ngFor="let col of viewColumns">{{ col }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of viewRows">
            <td *ngFor="let col of viewColumns">
              {{ row[col] }}
            </td>
          </tr>
          <tr *ngIf="!viewRows.length">
            <td [colSpan]="viewColumns.length" class="no-records-message">
              No records to show
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="pagination-controls" *ngIf="viewRows.length">
      <button type="button" class="btn-pagination" (click)="previousPage()" [disabled]="currentPage === 1">
        Previous
      </button>
      <span class="pagination-info">Page {{ currentPage }} of {{ totalPages }}</span>
      <button type="button" class="btn-pagination" (click)="nextPage()" [disabled]="currentPage >= totalPages">
        Next
      </button>
    </div>
  </div>

  <div class="overlay" *ngIf="isValidating || isUploading || isViewing" aria-live="polite" aria-busy="true" role="status">
    <div class="spinner" aria-hidden="true"></div>
    <div class="overlay-text">
      {{ isValidating ? 'Validating workbook…' : isUploading ? 'Uploading file…' : 'Fetching data…' }}
    </div>
  </div>
</div>